import React from 'react';

export default class ListItemWrapper<T> extends React.PureComponent<{ item: T; type: React.ReactType }, {}> {
    render() {
        const Type = this.props.type;

        return <Type className="collection-item" {...this.props} />;
    }
}
